import { render, staticRenderFns } from "./HelpCenterDetail.vue?vue&type=template&id=34948ebe&scoped=true&"
import script from "./HelpCenterDetail.vue?vue&type=script&lang=js&"
export * from "./HelpCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterDetail.vue?vue&type=style&index=0&id=34948ebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34948ebe",
  null
  
)

export default component.exports